var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDot2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.01 113.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb324;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.01,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.01,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.01,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.01,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 46.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 46.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.01,
    cy: 46.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.01,
    cy: 46.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 67.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 67.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.01,
    cy: 67.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.01,
    cy: 67.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 88.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 88.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.01,
    cy: 88.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.01,
    cy: 88.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 109.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 109.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.01,
    cy: 109.01,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.01,
    cy: 109.01,
    r: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot2);
export default __webpack_public_path__ + "static/media/dot-2.30f05f3b6a8c7b18fdfdc1b68f22e851.svg";
export { ForwardRef as ReactComponent };